var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadiation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.333 1.327h11m0 11h-11",
    stroke: "#131A4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.333 1.327v11",
    stroke: "#131A4F",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeDasharray: "1 2"
  })));
}
export default __webpack_public_path__ + "91d5e4bdbead43026b07a3a60286c8ca.svg";
export { SvgRadiation as ReactComponent };